import { CopiaContratoDocumentsESign } from "./copiaContratoDocumentsESign";

export class CopiaContratoNewSpaceOrquestradora {

  sucesso: boolean; //"Indicador se a resposta foi obtida com sucesso"
  origem: string; // "Tipo de origem dos dados"
  proposalCode: string; // "Código da proposta (Esign)"
  contractCode: string; // "Código do contrato (Esign/NewSpace/GCC)"
  keyHash: string; // "Hash da chave (Esign)"
  documentsEsign: CopiaContratoDocumentsESign; // "Lista de documentos no formato Esign"
  documentsZip: Array<string>; // "Documentos compactados em ZIP (Base64)"
  numeroContrato: string; // "Número do contrato (NewSpace)"
  dataBase: string; // "Data base do contrato (NewSpace)"
  documentsNewSpace: string; // "Documentos no formato NewSpace"
  status: string; // "Status da resposta (NewSpace/GCC)"
  mensagem: string; // "Mensagem associada à resposta (NewSpace/GCC)"
  dataAtendimento: string; // "Data de atendimento do contrato (NewSpace)"
  dataExpurgo: string; // "Data de expurgo do contrato (NewSpace)"
  qtdDiasAtendimento: number; // "Quantidade de dias para atendimento (NewSpace)"
  conteudoBase64: string; // "Conteúdo do documento em Base64 (GCC)"
  nomeArquivo: string; // "Nome do arquivo (GCC)"
  mimeType: string; // "Tipo MIME do arquivo (GCC)"
 
  constructor(){
    
  }
}



// WEBPACK FOOTER //
// /home/runner/_work/fini-sta-01-estatico-sitecliente/fini-sta-01-estatico-sitecliente/src/app/modelo/copiaContratoNewSpaceOrquestradora.ts